import React from 'react';
import { BedIcon, CalendarRangeIcon, CompassIcon, ClipboardListIcon, MoonIcon, RefreshCwIcon, ShieldCheckIcon, TimerIcon, MoonStarIcon } from 'lucide-react';
import { CtaBlock, CtaButton } from '../components/CtaButton';
import { FaqItem } from '../components/FaqItem';
import { InsidePages } from '../components/InsidePages';
import { StickyCta } from '../components/StickyCta';
import { GUARANTEE_TEXT, GUARANTEE_TITLE, faqs, guides, heroBenefits, offerIncludes, painPoints, testimonials } from '../data/content';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/3mwrhkUoCDtynSAjfGyryU/mockup2.png';
const LIFESTYLE_URL = 'https://cdn.magicpatterns.com/patterns/generated-images/e6a6c5cf-96a0-4b94-b2be-7cd50b5302df.jpg';
const benefitIcons = [CompassIcon, ClipboardListIcon, CalendarRangeIcon];
const painIcons = [TimerIcon, MoonIcon, BedIcon, RefreshCwIcon];
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-white font-body text-brand-charcoal" data-id="element-30" data-mp="3vnjq2glqqojc">
      {/* Header */}
      <header className="border-b border-brand-charcoal/10" data-id="element-31" data-mp="35t02ja53pua0">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-2.5 lg:px-8" data-id="element-32" data-mp="35rfabr69enfb">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-33" data-mp="30ugdv1z4i4dy">
            Prof.Kyra
          </p>
          <div className="flex items-center gap-4" data-id="element-34" data-mp="3ticak6oozwaq">
            <p className="font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/55" data-id="element-35" data-mp="3ti2kkj3ndp51">
              6 Guides · 23 USD
            </p>
            <CtaButton label="Get Access" size="md" className="hidden px-4 py-2 text-[11px] md:inline-flex" data-id="element-36" data-mp="3jk4vxuhvlqbw" />
          </div>
        </div>
      </header>

      <main data-id="element-37" data-mp="285rcr2y2hz27">
        {/* 01 — HERO */}
        <section className="px-5 pb-14 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-38" data-mp="286sxjz4vxzx4">
          <div className="mx-auto max-w-3xl text-center" data-id="element-39" data-mp="242l81zqlsfxu">
            <p className="flex items-center justify-center gap-2 font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-40" data-mp="25ktnqedhft9m">
              <MoonStarIcon className="h-3.5 w-3.5 text-brand-charcoal/40" strokeWidth={1.25} aria-hidden="true" data-id="element-41" data-mp="2ailfn8e4nfdt" />
              Real Solutions for Tired Parents
            </p>
            <h1 className="mt-5 font-display text-[2.3rem] font-bold leading-[1.06] tracking-[-0.01em] text-brand-charcoal sm:text-[3rem] lg:text-[3.5rem]" data-id="element-42" data-mp="20njpc984879n">
              Tired of 20-Minute Naps, Bedtime Battles &amp; Constant Night Wakings?
            </h1>
            <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-base" data-id="element-43" data-mp="1cxgz7ynrhbdo">
              Stop guessing when your baby should sleep. Get age-by-age wake windows, nap times and
              simple routines to build calmer, more predictable sleep from birth to 24 months.
            </p>
          </div>

          {/* Product */}
          <img src={MOCKUP_URL} alt="The Baby Sleep Bible by Prof. Kyra — the complete set of six digital sleep guides" className="mx-auto mt-10 block w-full max-w-[360px] object-contain lg:mt-12 lg:max-w-[560px]" data-id="element-44" data-mp="p890rnsuh5qb" />

          <div className="mx-auto mt-10 max-w-4xl" data-id="element-45" data-mp="y7cm6yfhhx7z">
            <ul className="grid gap-6 border-y border-brand-charcoal/10 py-7 sm:grid-cols-3" role="list" data-id="element-46" data-mp="t9b34di25xwi">
              {heroBenefits.map((benefit, index) => {
              const Icon = benefitIcons[index];
              return <li key={benefit.label} className="text-center" data-id="element-47" data-mp="1h0ghspc9ik58" data-mpi={index}>
                    <Icon className="mx-auto h-5 w-5 text-brand-charcoal/70" strokeWidth={1.25} aria-hidden="true" data-id="element-48" data-mp="1h1rlkp5pjrwc" />
                    <p className="mt-2.5 font-body text-[14px] font-semibold text-brand-charcoal" data-id="element-49" data-mp="1qvrwx8rl1tdi">
                      {benefit.label}
                    </p>
                    <p className="mx-auto mt-1 max-w-[16rem] text-[13px] leading-relaxed text-brand-charcoal/60" data-id="element-50" data-mp="260cwe119olbr">
                      {benefit.description}
                    </p>
                  </li>;
            })}
            </ul>

            <p className="mt-8 text-center font-body text-xl font-semibold leading-none text-brand-charcoal sm:text-2xl" data-id="element-51" data-mp="2js9k7svwk92c">
              23 USD
              <span className="ml-2 align-baseline font-body text-[12px] font-normal uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-52" data-mp="1n3le9uxgoc9a">
                · Complete System
              </span>
            </p>

            <div id="hero-cta" className="mt-5" data-id="element-53" data-mp="1w1dm6e0ushmn">
              <CtaBlock label="Get the Baby Sleep Bible — 23 USD" microcopy="Instant Digital Access • 6 Guides • One-Time Payment" data-id="element-54" data-mp="211rwk2pxg3nu" />
            </div>
          </div>
        </section>

        {/* 02 — PROBLEM */}
        <section aria-labelledby="problem-heading" className="bg-[#F4EEE4] px-5 py-14 lg:px-8 lg:py-20" data-id="element-55" data-mp="3cfdjdh8bdt67">
          <div className="mx-auto max-w-2xl text-center" data-id="element-56" data-mp="vv1qqs4uy0o8">
            <h2 id="problem-heading" className="font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-57" data-mp="vvjvye9hzp8a">
              When Sleep Changes, Everything Changes.
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-58" data-mp="i33qz7x1dh4q">
              Your baby&apos;s sleep can be unpredictable. You shouldn&apos;t have to start your
              research from zero every time something shifts.
            </p>
          </div>

          <div className="mx-auto mt-10 grid max-w-5xl items-center gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14" data-id="element-59" data-mp="870n9xmjdafo">
            <img src={LIFESTYLE_URL} alt="A baby sleeping calmly in a quiet, neutral nursery" loading="lazy" decoding="async" className="aspect-[4/5] w-full rounded-[14px] object-cover" data-id="element-60" data-mp="22iyll4jb4lws" />
            <ul className="border-t border-brand-charcoal/12" role="list" data-id="element-61" data-mp="3ry9at81njepl">
              {painPoints.map((pain, index) => {
              const Icon = painIcons[index];
              return <li key={pain} className="flex items-center gap-3.5 border-b border-brand-charcoal/12 py-4" data-id="element-62" data-mp="3i03aguvhugmu" data-mpi={index}>
                    <Icon className="h-[18px] w-[18px] flex-none text-brand-charcoal/55" strokeWidth={1.25} aria-hidden="true" data-id="element-63" data-mp="emr1d8pt3kl7" />
                    <span className="text-[15px] leading-snug text-brand-charcoal" data-id="element-64" data-mp="5kht6pi0g3az">{pain}</span>
                  </li>;
            })}
            </ul>
          </div>

          <CtaBlock label="Get Instant Access — 23 USD" className="mx-auto mt-12 max-w-md" data-id="element-65" data-mp="2qa7790aw3l2m" />
        </section>

        {/* 03 — THE SYSTEM */}
        <section aria-labelledby="system-heading" className="px-5 py-14 lg:px-8 lg:py-20" data-id="element-66" data-mp="2ua90qm6h186t">
          <div className="mx-auto max-w-6xl" data-id="element-67" data-mp="2muvwzhrpkx6m">
            <div className="mx-auto max-w-2xl text-center" data-id="element-68" data-mp="2hurhnv2je8hz">
              <p className="font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-69" data-mp="2wr8p4b7lv2z9">
                The System
              </p>
              <h2 id="system-heading" className="mt-4 font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-70" data-mp="2rsp1m6dd5j4s">
                One Sleep System. Six Essential Guides.
              </h2>
              <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-71" data-mp="2dsweel11pl1k">
                Each guide covers a different challenge and stage, so the system stays with you as
                your baby grows and sleep keeps shifting.
              </p>
            </div>

            <ol className="mt-10 grid gap-x-14 border-t border-brand-charcoal/12 sm:grid-cols-2" data-id="element-72" data-mp="1gd0enf040k3z">
              {guides.map(guide => <li key={guide.number} className="flex items-start gap-4 border-b border-brand-charcoal/12 py-6" data-id="element-73" data-mp="uupfj9d8kdr8">
                  <span className="mt-0.5 flex h-9 w-9 flex-none items-center justify-center rounded-full font-body text-[12px] font-semibold text-brand-charcoal" style={{
                backgroundColor: guide.accent
              }} aria-hidden="true" data-id="element-74" data-mp="14rv9cpd8iiv5">
                    {guide.number}
                  </span>
                  <span data-id="element-75" data-mp="1ips6bmvlorac">
                    <span className="block font-display text-[1.35rem] font-bold leading-snug text-brand-charcoal" data-id="element-76" data-mp="1nicw8dbdyk8l">
                      {guide.title}
                    </span>
                    <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-77" data-mp="1sjipqdcvebj6">
                      {guide.description}
                    </span>
                  </span>
                </li>)}
            </ol>
          </div>
        </section>

        {/* 04 — A LOOK INSIDE */}
        <section aria-labelledby="inside-heading" className="bg-[#F7F2E9] px-5 py-14 lg:px-8 lg:py-20" data-id="element-78" data-mp="3lxsji0d1az2w">
          <div className="mx-auto max-w-6xl" data-id="element-79" data-mp="3cyoxoomhg5kp">
            <div className="mx-auto max-w-2xl text-center" data-id="element-80" data-mp="3d1kug9mlgo7k">
              <p className="font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-81" data-mp="381fc5k27se25">
                A Look Inside
              </p>
              <h2 id="inside-heading" className="mt-4 font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-82" data-mp="4jna1cud6dq8">
                Practical Guidance for Real Life.
              </h2>
              <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-83" data-mp="3qyq9v0876zfh">
                Clear schedules, practical guidance and easy-reference tools designed for tired
                parents.
              </p>
            </div>

            <div className="mt-12" data-id="element-84" data-mp="31e8c5f733wkk">
              <InsidePages data-id="element-85" data-mp="31fb13hkujoxu" />
            </div>

            <CtaBlock label="Get the Complete System — 23 USD" microcopy="6 Digital Guides • Instant Access • One-Time Payment" className="mx-auto mt-12 max-w-md border-t border-brand-charcoal/12 pt-10" data-id="element-86" data-mp="31g2xuvq6jspp" />
          </div>
        </section>

        {/* 05 — TESTIMONIALS */}
        <section aria-labelledby="testimonials-heading" className="px-5 py-14 lg:px-8 lg:py-20" data-id="element-87" data-mp="3kcu9qk3e75jq">
          <div className="mx-auto max-w-6xl" data-id="element-88" data-mp="3feammgd2bnps">
            <h2 id="testimonials-heading" className="text-center font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-89" data-mp="3fdhq087tield">
              What Parents Say.
            </h2>
            <div className="mt-10 grid gap-10 sm:grid-cols-3 sm:gap-8" data-id="element-90" data-mp="6y7i2jh8yf5o">
              {testimonials.map(testimonial => <blockquote key={testimonial.name} className="border-t border-brand-charcoal/20 pt-6" data-id="element-91" data-mp="1zw725f7tylv">
                  <p className="font-display text-[1.3rem] font-normal italic leading-[1.45] text-brand-charcoal" data-id="element-92" data-mp="littw7xtjbai">
                    “{testimonial.quote}”
                  </p>
                  <footer className="mt-5" data-id="element-93" data-mp="cjow53u2zlze">
                    <p className="font-body text-[13px] font-semibold text-brand-charcoal" data-id="element-94" data-mp="gljubzgptj8y">
                      {testimonial.name}
                    </p>
                    <p className="mt-0.5 font-body text-[12px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-95" data-mp="2t3wre6l2dff">
                      {testimonial.country}
                    </p>
                  </footer>
                </blockquote>)}
            </div>
          </div>
        </section>

        {/* 06 — FINAL OFFER */}
        <section id="offer" aria-labelledby="offer-heading" className="bg-[#F4EEE4] px-5 py-14 lg:px-8 lg:py-20" data-id="element-96" data-mp="3g170306qg8uj">
          <div className="mx-auto max-w-3xl text-center" data-id="element-97" data-mp="3kzib3e8rkpec">
            <p className="flex items-center justify-center gap-2 font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-98" data-mp="1qkcvd8ak3910">
              The Complete Bundle
              <span aria-hidden="true" className="text-brand-charcoal/30" data-id="element-99" data-mp="1gtqk1q9vh4o4">
                ✦ ✦
              </span>
            </p>
            <h2 id="offer-heading" className="mt-4 font-display text-[2.2rem] font-bold leading-[1.08] text-brand-charcoal sm:text-[2.6rem]" data-id="element-100" data-mp="1ctg1zf8t2nsw">
              The Baby Sleep Bible
            </h2>

            <img src={MOCKUP_URL} alt="The Baby Sleep Bible — six digital guides included in the bundle" loading="lazy" decoding="async" className="mx-auto mt-8 block w-full max-w-[320px] object-contain lg:max-w-[420px]" data-id="element-101" data-mp="24hhwquzbrjpx" />

            <ul className="mx-auto mt-8 inline-flex flex-col gap-2.5 text-left" role="list" data-id="element-102" data-mp="p0rajms5m8n5">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/75" data-id="element-103" data-mp="2vrmd9iylh66q">
                  <span aria-hidden="true" className="mt-2 h-1 w-1 flex-none rounded-full bg-brand-charcoal/40" data-id="element-104" data-mp="30ntfb0nvdxje" />
                  {item}
                </li>)}
            </ul>

            <div className="mx-auto mt-9 max-w-md border-t border-brand-charcoal/15 pt-8" data-id="element-105" data-mp="3egj2h8f4x8i3">
              <p className="font-body text-[2.5rem] font-bold leading-none text-brand-charcoal" data-id="element-106" data-mp="3jfm6cpjdp8oh">
                23 USD
                <span className="ml-2 align-baseline font-body text-[12px] font-normal uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-107" data-mp="3og9t2z0kr3cw">
                  · One-Time Payment
                </span>
              </p>
              <CtaBlock label="Get the Baby Sleep Bible — 23 USD" microcopy="Instant Digital Access • 6 Guides" className="mt-7" data-id="element-108" data-mp="1u3tsoeugmjfy" />
            </div>
          </div>
        </section>

        {/* 07 — FAQ */}
        <section aria-labelledby="faq-heading" className="px-5 py-14 lg:px-8 lg:py-20" data-id="element-109" data-mp="yqsm876lwieu">
          <div className="mx-auto max-w-3xl" data-id="element-110" data-mp="1cqag30yrelv2">
            <h2 id="faq-heading" className="text-center font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-111" data-mp="1cp914lemhf82">
              Questions, Answered.
            </h2>
            <div className="mt-8 border-t border-brand-charcoal/12" data-id="element-112" data-mp="f43c9taa4xjr">
              {faqs.map(faq => <FaqItem key={faq.question} {...faq} data-id="element-113" data-mp="tszeh9pnngcg" />)}
            </div>
          </div>
        </section>

        {/* Guarantee */}
        <section aria-labelledby="guarantee-heading" className="border-y border-brand-charcoal/10 bg-[#F7F2E9] px-5 py-12 lg:px-8" data-id="element-114" data-mp="p0g56oy037dg">
          <div className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-115" data-mp="3shg6n6xecjs8">
            <ShieldCheckIcon className="h-6 w-6 text-brand-charcoal/60" strokeWidth={1.25} aria-hidden="true" data-id="element-116" data-mp="27zx85u3yn721" />
            <h2 id="guarantee-heading" className="mt-4 font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-117" data-mp="2ct06efjon4ok">
              {GUARANTEE_TITLE}
            </h2>
            <p className="mt-3 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-118" data-mp="2qqevtk9xrcgj">
              {GUARANTEE_TEXT}
            </p>
          </div>
        </section>
      </main>

      {/* 08 — FOOTER */}
      <footer className="bg-brand-charcoal px-5 pb-32 pt-12 text-brand-white/70 md:pb-12 lg:px-8" data-id="element-119" data-mp="2hr1nww1gmvxx">
        <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-120" data-mp="2mojzyvarxra5">
          <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-white" data-id="element-121" data-mp="16a1u1vzgs91s">
            Prof.Kyra
          </p>
          <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-122" data-mp="1b7tn4tbui17k">
            <a href="#terms" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-white/60" data-id="element-123" data-mp="3d16llcf7r7ph">
              Terms
            </a>
            <a href="#privacy" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-white/60" data-id="element-124" data-mp="2z5upp1pbnb6z">
              Privacy Policy
            </a>
            <a href="#refund" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-white/60" data-id="element-125" data-mp="2kcrah0z7d9jf">
              Refund Policy
            </a>
            <a href="mailto:profkyra@gmail.com" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-white/60" data-id="element-126" data-mp="eflxll9wxp6l">
              Contact
            </a>
          </nav>
        </div>
        <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-white/45" data-id="element-127" data-mp="2a6zpa3cmqcme">
          © 2026 Prof.Kyra. The Baby Sleep Bible is an educational resource and does not constitute
          medical advice. 7-day money-back guarantee. Payments are processed in your local currency.
        </p>
      </footer>

      <StickyCta data-id="element-128" data-mp="1mfly40q7sn30" />
    </div>;
}